// Rad Hourly Volume Share Action Types - start
export const FETCH_RAD_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_REQUEST = 'FETCH_RAD_HOURLY_VOLUME_SHARE_UN_READ_RVU_DETAILS_REQUEST';
export const FETCH_RAD_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_SUCCESS = 'FETCH_RAD_HOURLY_VOLUME_SHARE_UN_READ_RVU_DETAILS_SUCCESS';
export const FETCH_RAD_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_FAILURE = 'FETCH_RAD_HOURLY_VOLUME_SHARE_UN_READ_RVU_DETAILS_FAILURE';

export const FETCH_RAD_HOURLY_VOLUME_SHARE_READ_DETAILS_REQUEST = 'FETCH_RAD_HOURLY_VOLUME_SHARE_READ_RVU_DETAILS_REQUEST';
export const FETCH_RAD_HOURLY_VOLUME_SHARE_READ_DETAILS_SUCCESS = 'FETCH_RAD_HOURLY_VOLUME_SHARE_READ_RVU_DETAILS_SUCCESS';
export const FETCH_RAD_HOURLY_VOLUME_SHARE_READ_DETAILS_FAILURE = 'FETCH_RAD_HOURLY_VOLUME_SHARE_READ_RVU_DETAILS_FAILURE';

export const EXPORT_RAD_HOURLY_VOLUME_SHARE_REQUEST = 'EXPORT_RAD_HOURLY_VOLUME_SHARE_REQUEST';
export const EXPORT_RAD_HOURLY_VOLUME_SHARE_SUCCESS = 'EXPORT_RAD_HOURLY_VOLUME_SHARE_SUCCESS';
export const EXPORT_RAD_HOURLY_VOLUME_SHARE_FAILURE = 'EXPORT_RAD_HOURLY_VOLUME_SHARE_FAILURE';

export const GET_DORPDOWN_RAD_SITES_REQUEST = 'GET_DROPDOWN_RAD_SITES_REQUEST';
export const GET_DORPDOWN_RAD_SITES_SUCCESS = 'GET_DROPDOWN_RAD_SITES_SUCCESS';
export const GET_DORPDOWN_RAD_SITES_FAILURE = 'GET_DROPDOWN_RAD_SITES_FAILURE';

export const GET_WORKLIST_BY_RPCE_ID_REQUEST = 'GET_WORKLIST_BY_RPCE_ID_REQUEST';
export const GET_WORKLIST_BY_RPCE_ID_SUCCESS = 'GET_WORKLIST_BY_RPCE_ID_SUCCESS';
export const GET_WORKLIST_BY_RPCE_ID_FAILURE = 'GET_WORKLIST_BY_RPCE_ID_FAILURE';

export const GET_PRATICES_BY_WORKLIST_ID_REQUEST = 'GET_PRATICES_BY_WORKLIST_ID_REQUEST';
export const GET_PRATICES_BY_WORKLIST_ID_SUCCESS = 'GET_PRATICES_BY_WORKLIST_ID_SUCCESS';
export const GET_PRATICES_BY_WORKLIST_ID_FAILURE = 'GET_PRATICES_BY_WORKLIST_ID_FAILURE';

export const GET_SUB_PRATICES_BY_PRATICE_ID_REQUEST = 'GET_SUB_PRATICES_BY_PRATICE_ID_REQUEST';
export const GET_SUB_PRATICES_BY_PRATICE_ID_SUCCESS = 'GET_SUB_PRATICES_BY_PRATICE_ID_SUCCESS';
export const GET_SUB_PRATICES_BY_PRATICE_ID_FAILURE = 'GET_SUB_PRATICES_BY_PRATICE_ID_FAILURE';

export const GET_SITE_BY_SUB_PRATICE_ID_REQUEST = 'GET_SITE_BY_SUB_PRATICE_ID_REQUEST';
export const GET_SITE_BY_SUB_PRATICE_ID_SUCCESS = 'GET_SITE_BY_SUB_PRATICE_ID_SUCCESS';
export const GET_SITE_BY_SUB_PRATICE_ID_FAILURE = 'GET_SITE_BY_SUB_PRATICE_ID_FAILURE';
// Rad Hourly Volume Share Action Types - end